import { ChangeDetectionStrategy, Component, HostListener, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { PanelModule } from 'primeng/panel';
import { PanelComponent } from '../panel/panel.component';
import { PanelConfigI } from '../../interfaces';
import { TranslatePipe } from '@ngx-translate/core';
import { TranslationService } from '../../services/translation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'dashboard-filters',
  templateUrl: './dashboard-filters.component.html',
  styleUrl: './dashboard-filters.component.scss',
  standalone: true,
  imports: [
    DatePickerModule,
    FormsModule,
    PanelModule,
    ButtonModule,
    PanelComponent,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardFiltersComponent implements OnInit {
  translateService = inject(TranslationService);
  langChangeSub!: Subscription;
  ngOnInit(): void {
    this.updateHeaderLabel();

    this.langChangeSub = this.translateService.onLangChange.subscribe(() => {
      this.updateHeaderLabel();
    });
  }

  ngOnDestroy(): void {
    this.langChangeSub?.unsubscribe();
  }
  private updateHeaderLabel(): void {
    this.panelConfig.headerLabel = this.translateService.getTranslation(
      'PROVIDER_PEER_COMPARISONS.FILTERS'
    );
  }



  showFilters: boolean = false;
  rangeDates: any;
  panelConfig: PanelConfigI = {
    toggleable: true,
    collapsed: true,
    headerIcon: 'fa-solid fa-filter',
    headerLabel: inject(TranslationService).getTranslation('PROVIDER_PEER_COMPARISONS.FILTERS'),
    expandIcon: undefined,
    collapseIcon: undefined,
  };
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  resetRows() {
    this.resetFields();
  }

  resetFields() {
    //reset the value to empty string
    let selectTag = document.querySelectorAll('select');
    selectTag.forEach((element) => {
      element.value = '';
    });

    //Clears ID field
    const id = document.querySelector('input[name="id"]') as HTMLInputElement;
    id.value = 'Filter by ID...';
    //Clears Date Field
    const fromDateInput = document.querySelector(
      'input[name="fromDate"]'
    ) as HTMLInputElement;
    const toDateInput = document.querySelector(
      'input[name="toDate"]'
    ) as HTMLInputElement;

    fromDateInput.value = '';
    toDateInput.value = '';
  }

  apply() {
    // this.updateFilterByDateRange();
    // this.updateFilterBySystemResult();
  }

  /*Listens for key press  and updates the result*/
  @HostListener('document:keyup', ['$event'])
  handleEnterKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.apply();
    }
  }
}
